import { Link, useLocation } from "react-router-dom";

const Breadcrumb = () => {
  const location = useLocation();

  // Hide breadcrumb on home page
  if (location.pathname === "/" || location.pathname === "/home") {
    return null;
  }

  const paths = location.pathname.split("/").filter(Boolean);

  return (
    <div className="breadcrumb-section">
      <div className="container">
        <Link to="/">Home</Link>

        {paths.map((item, index) => {
          const url = "/" + paths.slice(0, index + 1).join("/");

          return (
            <span key={url}>
              {" / "}
              {index === paths.length - 1 ? (
                <span>
                  {item.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
                </span>
              ) : (
                <Link to={url}>
                  {item.replace(/-/g, " ").replace(/\b\w/g, c => c.toUpperCase())}
                </Link>
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumb;